import { Div, RefString, Select, SelectOption } from "@tblabs/truffle";
import { BasketItem } from "../Models/Basket/BasketItem";
import { Product } from "../Shop/Product";
import { ProductOption } from "../Shop/ProductOption";


export class ProductSelector extends Div
{
    private productId = new RefString().OnChange(() => this.Refresh())
    private optionId = new RefString().OnChange(() => this.Refresh())

    constructor(
        private products: Product[],
        private basketItem: BasketItem)
    {
        super();

        const productsNames = products.map(p => new SelectOption(p.Title.value, p.Id));

        this.productId.value = this.basketItem?.ProductInfo?.Id || "";
        this.optionId.value = this.basketItem?.Option?.Id || "";

        this.Append(
            new Select(this.productId, productsNames)
                .WidthAuto(),
            new Select(this.optionId, () => this.OptionsOfSelectedProduct(products), this.productId).WidthAuto()
                .AddDefaultOption("(wybierz opcję)")
                .VisibleWhen(this.productId, () => this.OptionsOfSelectedProduct(products).length > 0)
        );
    }

    private OptionsOfSelectedProduct(productsInfo: Product[]): SelectOption<string>[]
    {
        const product = productsInfo.find(x => x.Id == this.productId.value);

        const productOptions = product?.Options.List.Items.map(o => new SelectOption(o.Label.value, o.Url.value)) || [];

        return productOptions;
    }

    public Refresh(): void
    {
        const product: Product | undefined = this.products.find(x => x.Id == this.productId.value);

        if (!product)
            return;

        const option: ProductOption = product.Options.List.Find(o => o.Url.value == this.optionId.value) || ProductOption.Default;

        this.basketItem.Set(product, option);
    }
}
